import {Injectable} from '@angular/core';
import {LoginHelper} from '../helpers';

import {AuthenticationService} from './index';
import {Subject} from "rxjs";
import {Load} from "../_decorators/loading.decorator";
import {HttpClient} from "@angular/common/http";
import {IndexConfigService} from "./index.config.service";
import {FixDates} from "../_decorators/date.decorator";

@Injectable()
export class AssessmentService {
  updateList = new Subject();

  constructor(public http: HttpClient,
              public authenticationService: AuthenticationService,
              public config: IndexConfigService) {
  }

  @Load()
  @FixDates()
  getAssessmentResults(all: boolean = false) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.get<any>(this.config.api + '/api/assessments/result/' + all);
  }

  @Load()
  getAssessmentVersionList(assessmentId: number) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.get<any>(this.config.api + '/api/assessments/versions?assessmentId=' + assessmentId);
  }

  @Load()
  @FixDates()
  getUserAssessmentResults() {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.get<any>(this.config.api + '/api/assessments/result/user');
  }

  @Load()
  @FixDates()
  getLastUnfinishedAssessmentResults(assessmentId: number) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.get<any>(this.config.api + '/api/assessments/result/last' + '?assessmentId=' + assessmentId);
  }

  @Load()
  @FixDates()
  getAssessmentResult(answersId: number) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.get<any>(this.config.api + '/api/assessments/result/single' + '?answersId=' + answersId);
  }

  @Load()
  addAssessmentAnswers(result: any) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.post<any>(this.config.api + '/api/assessments/result', result);
  }

  @Load()
  saveAssessment(result: any) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.post<any>(this.config.api + '/api/assessments', result);
  }

  @Load()
  inviteToAssessment(assessment: any, inviteText: string) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.post<any>(this.config.api + '/api/assessments/invite', {...assessment, inviteText: inviteText});
  }

  @Load()
  getAllAssessments() {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.get<any>(this.config.api + '/api/assessments');
  }

  @Load()
  assessmentExists(id, name) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.get<any>(this.config.api + '/api/assessments/' + id + '/name?name=' + encodeURIComponent(name));
  }

  @Load()
  getAssessment(id) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.get<any>(this.config.api + '/api/assessments/' + id);
  }

  @Load()
  deleteAssessment(id) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.delete(this.config.api + '/api/assessments/' + id);
  }

  @Load()
  deleteAssessmentAnswer(id) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.delete(this.config.api + '/api/assessments/answer/' + id);
  }

  @Load()
  uploadAttachment(entity) {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    let formData = new FormData();

    formData.append(entity.name, entity, entity.name);

    return this.http
      .post<any>(this.config.api + '/api/assessments/attachment', formData)
      ;

  }

  @Load()
  importAssessment(entity, name) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    let formData = new FormData();

    formData.append(entity.name, entity, entity.name);

    return this.http
      .post<any>(this.config.api + '/api/assessments/import?name=' + encodeURIComponent(name), formData)
      ;
  }

  @Load()
  exportAnswers(id, resultId, userIds, fromDate, toDate) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.get(this.config.api + '/api/assessments/' + id + `/exportResults?${resultId ? 'resultId=' + resultId : ''}` + '&from=' + (fromDate && fromDate.toISOString ? fromDate.toISOString() : '') + '&to=' + (toDate && toDate.toISOString ? toDate.toISOString() : '') + '&userIds=' + (userIds || []).join(','), {responseType: 'arraybuffer'});
  }
}
